import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { getApiUrl } from "../config";

const Link = () => {
  const a = window.location.href;
  const {r}=useParams();

 
 
  useEffect(() => {
    const sendVisitData = async (a) => {
     
      const afterR = a.split('?')[1]; 
  
      if(!afterR){
        return;
      }
      try {
        await axios.get(`${getApiUrl()}/kampanya?${afterR}`)
      } catch (error) {
        console.error("GET isteği başarısız:", error);
      }
    };
  
    sendVisitData(a);
  }, [a,r]); 

  return null; 
};


export default Link;